import React from 'react'
import Dropdown, {
    MenuItem,
} from '@trendmicro/react-dropdown'
import Checkbox from './Checkbox'
import '!style-loader!css-loader!./dropdown.css'
import { FontIcon } from 'react-toolbox/lib/font_icon'
import { select } from 'redux-saga/effects'
import { defaultSearchFilterNames } from '../constants'


const FilterDropdown = ({
    sourceFilters,
    selectedFilters,
    otherSource,
    onClick
}) => {

    return (
        <Dropdown>
            <Dropdown.Toggle>
                <FontIcon value='filter_list' />
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ 'height': '30vh', 'overflow-y': 'auto' }}>
                {
                    sourceFilters.map((filter, idx) => {
                        return <MenuItem>
                            <Checkbox
                                isChecked={selectedFilters.includes(filter)}
                                key={idx}
                                label={defaultSearchFilterNames[filter]}
                                value={filter}
                                onClick={onClick}
                            />
                        </MenuItem>
                    })
                }
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default FilterDropdown